import * as ng from 'angular';
import { GoogleDriveService } from '../../../services/google-drive.service';

class GoogleDriveAuthController implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$location',
        'GoogleDriveService',
        'store'
    ];

    constructor(
        private $rootScope: any, // ng.IRootScopeService,
        private $location: ng.ILocationService,
        private GoogleDriveService: GoogleDriveService,
        private store: ng.a0.storage.IStoreService
    ) {
        let code = $location.search().code;

        let fireAuthorizationEnd = (user) => {
            window.opener.parentScope.user = user;
            window.opener.parentScope.googleDriveAuthorizationDone = true;
            window.opener.parentScope.$apply();

        };

        let authorize = () => {
            GoogleDriveService.authorize(code)
                .then((response) => {
                    store.set('user', response);
                    fireAuthorizationEnd(response);
                })
                .catch((error) => {
                    $rootScope.alert('error', error.data);
                });
        };

        if (code !== undefined && code !== '') {
            authorize();
        } else {
            if (window.opener) {
                window.opener.parentScope.authorizationError = true;
                window.opener.parentScope.$apply();
            }
        }
    }
}

export const GoogleDriveAuthComponent: ng.IComponentOptions = {
    template: require('./google-drive-auth.html'),
    controller: GoogleDriveAuthController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/google-drive-auth/google-drive-auth.ts